import React, { Component } from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';
import dotAccess from 'dot-access';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import './Table.css';

class ExpandableContentRow extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  handleToggleExpand = () => {
    const toggled = !this.state.expanded;
    this.setState({ expanded: toggled });
  };

  renderExpandedContent = (expandedData) => {
    if (!this.state.expanded) {
      return;
    }

    const { children, expand } = this.props;
    const expandedRow = expand(expandedData);

    return (
      <tr className="ExpandableRowContent">
        <td colSpan={children.length + 1}>{expandedRow}</td>
      </tr>
    );
  };

  renderExpandableRow = (row, expandedContent) => {
    if (expandedContent !== undefined && !expandedContent.length) {
      return (
        <tbody>
          <tr>{row}<td></td></tr>
        </tbody>
      );
    }

    return (
      <tbody>
        <tr className="ExpandableRow" onClick={this.handleToggleExpand}>
          {row}
          <td>{this.state.expanded ? <ChevronUp /> : <ChevronDown />}</td>
        </tr>
        {this.renderExpandedContent(expandedContent)}
      </tbody>
    );
  };

  render() {
    const { children, data, handleRemove, handleResend, updateResults, name, expandProperty } = this.props;
    const expandedContent = dotAccess.get(data, expandProperty);

    const row = React.Children.map(children,
      child => React.cloneElement(child, {
        data: data,
        handleRemove: handleRemove,
        handleResend: handleResend,
        updateResults: updateResults,
        name: name,
        ...child.props,
      })
    );

    return this.renderExpandableRow(row, expandedContent);
  }

}

const changeOrdering = (name, ordering, asc, handleFilterChange) => {
  if (ordering === name) {
    handleFilterChange({ target: { name: 'asc', value: asc === 'true' ? 'false' : 'true' } });
  } else {
    handleFilterChange({ target: { name: 'order', value: name } });
  }
};

const OrderingIcon = props => (
  <span>
    {props.asc === 'false' ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
  </span>
);

const renderHeader = (locale, label, name, ordering, asc, handleFilterChange) => (
  name ?
    <th className="orderable"
        onClick={() => changeOrdering(name, ordering, asc, handleFilterChange)}>
      {getLabel(locale, label)}
      {(ordering === name) ? <OrderingIcon asc={asc} /> : ''}
    </th> :
    <th>{getLabel(locale, label)}</th>
);

const ExpandableTable = (props, context) => {
  const { data, children, filters, handleFilterChange } = props;

  const header = React.Children.map(children,
      (child, i) => renderHeader(context.locale,
                                child.props.label,
                                child.props.orderingName,
                                filters.order,
                                filters.asc,
                                handleFilterChange)
  );

  return (
    <table className="Table ExpandableTable">
      <thead>
        <tr>
          {header}
          <td></td>
        </tr>
      </thead>
      {data !== undefined && data.length ?
        data.map((d, i) =>
          <ExpandableContentRow {...props} key={i} data={d} />
        ) :
        <tbody>
          <tr><td colSpan={children.length + 1}>Nessun Risultato</td></tr>
        </tbody>
      }
    </table>
  );
};

ExpandableTable.contextTypes = {
  locale: PropTypes.string,
};

export default ExpandableTable;



// WEBPACK FOOTER //
// ./src/main/components/container/ExpandableTable.js